import type { FC } from "react";

import { m } from "@recobra/i18n/messages";
import type { Task } from "@recobra/schemas/task";
import { ExpandableText } from "@recobra/ui/custom/expandable-text";
import { Field, FieldDescription, FieldGroup, FieldTitle } from "@recobra/ui/field";

import { UserLabel } from "../../lib";
import { TaskModalSection, formatTaskTimestamp } from "../task-display";

/** Execution notes and the cancellation entry the viewer may see; nothing when neither is visible. */
export const TaskCancellationDetails: FC<{ task: Task }> = ({ task }) => {
  const cancellation = task.history?.findLast((entry) => entry.action === "cancel");
  if (!task.notes && !cancellation) return null;

  return (
    <TaskModalSection>
      <FieldGroup>
        {task.notes ? (
          <Field>
            <FieldTitle>{m.task_outcome_notes_label()}</FieldTitle>
            <ExpandableText text={task.notes} scrollable />
          </Field>
        ) : null}
        {cancellation ? (
          <>
            <Field>
              <FieldTitle>{m.task_cancellation_reason()}</FieldTitle>
              <ExpandableText text={cancellation.notes ?? ""} scrollable />
            </Field>
            <Field>
              <FieldTitle>{m.task_canceled_by()}</FieldTitle>
              <UserLabel userId={cancellation.updatedBy} />
              <FieldDescription>
                <time dateTime={cancellation.updatedAt}>
                  {formatTaskTimestamp(cancellation.updatedAt)}
                </time>
              </FieldDescription>
            </Field>
          </>
        ) : null}
      </FieldGroup>
    </TaskModalSection>
  );
};
